import { render, staticRenderFns } from "./contentCard.vue?vue&type=template&id=14db486b&scoped=true&"
import script from "./contentCard.vue?vue&type=script&lang=js&"
export * from "./contentCard.vue?vue&type=script&lang=js&"
import style0 from "./contentCard.vue?vue&type=style&index=0&id=14db486b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db486b",
  null
  
)

export default component.exports